import ionicons from 'style/ionicons/ionicons'
import { rwd } from '@stokr/components-library'
import { createGlobalStyle } from 'styled-components'
import interBitcoinSign from 'style/fonts/inter-bitcoin-sign.woff2'

/** The Open Sans weights Document.jsx loads from Google Fonts. */
const BITCOIN_SIGN_WEIGHTS = [300, 400, 600, 700, 800]

export const BaseCss = createGlobalStyle`
${ionicons};

  /* Open Sans draws the Bitcoin sign as a serif B; this one character (and only it) comes from
     Inter (OFL). One face per weight the site loads, matching Google's Open Sans faces exactly, and
     declared after them, so it wins for U+20BF at every weight. */
  ${BITCOIN_SIGN_WEIGHTS.map(
    (weight) => `
  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: ${weight};
    font-display: swap;
    src: url(${interBitcoinSign}) format('woff2');
    unicode-range: U+20BF;
  }`,
  ).join('')}

  body, html {
    min-width: 320px;
    min-height: 100vh;
    width: 100%;
    height: 100%;
    position: relative;
    margin: 0;
  }

  body img {
    max-width: 100%;
    max-height: auto;
  }

  /*
   * !important: a federated remote's own CSS (e.g. semantic-ui-css, loaded
   * as a bare module-level import) can inject its own \`a { color: ... }\`
   * globally into this document once its chunk loads, and never unloads it
   * on unmount/navigation — leaking that page's link color into every other
   * route for the rest of the session. Force it so the host always wins.
   */
  a, a:visited, a:hover, a:active {
    text-decoration: none;
  }

  /*
   * The colour half is excluded on remote routes (<body class="mf-remote-route">,
   * see style/HostGlobalStyles.tsx). BaseCss is mounted on every route by design,
   * so without this the host dictates link colour inside every remote — the leak
   * defence above was only ever meant to protect host pages.
   *
   * text-decoration stays global on purpose: it has no !important (a remote can
   * override it freely) and dropping it on remote routes would hand their links
   * back the user-agent underline.
   *
   * :where() keeps specificity identical to the bare selectors — a plain
   * :not(.mf-remote-route a) would inherit its argument's specificity and start
   * outranking rules that are supposed to win.
   *
   * Anchors rendered by the library Button (it sets type="button" even as <a>)
   * are excluded so the component color wins. Primary is blue background with
   * white text. A generated class cannot beat a:visited (0, 1, 1) + !important,
   * which is why a color class only stuck on :hover. :where() keeps the
   * exclusion at 0 specificity.
   */
  a:not(:where(.mf-remote-route a)):not(:where([type='button'])),
  a:visited:not(:where(.mf-remote-route a)):not(:where([type='button'])),
  a:hover:not(:where(.mf-remote-route a)):not(:where([type='button'])),
  a:active:not(:where(.mf-remote-route a)):not(:where([type='button'])) {
    color: inherit !important;
  }

  #root {
    margin: 0 auto;
    position:relative;
    /* overflow: hidden */
  }

  /* Admin / other remotes: a wide table must not make the phone pan sideways.
     Clip the document; the table keeps its own horizontal scroller. */
  ${rwd.MLarge`
    html:has(body.mf-remote-route) {
      overflow-x: hidden;
      overflow-x: clip;
    }

    body.mf-remote-route,
    body.mf-remote-route #root {
      max-width: 100%;
      overflow-x: hidden;
      overflow-x: clip;
    }
  `}

  .svgClass {
    max-height:600px;
    &> svg {
      max-height:600px;
    }
  }

  .contact-us-button {
    cursor: pointer;
    position: relative;
  }

  .white-button {
    color: black;
    &:hover, &:focus{
      color: white !important;
    }
  }

  /*
   * iOS zooms the page into any focused field under 16px (login, sign-up, selects).
   * Touch screens only; desktop keeps its sizes. Host pages only: federated apps (e.g. the
   * 34px invest-in-sto amount) style their own. Fields already above 16px opt out with
   * data-keep-font-size, since CSS can't apply "at least 16px".
   */
  @media (pointer: coarse) {
    body:not(.mf-remote-route) :is(input, select, textarea):not([data-keep-font-size]) {
      font-size: 16px !important;
    }
  }
`

export default BaseCss
